import { Component, computed, effect, inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MenuItem } from 'primeng/api';
import { PanelMenuModule } from 'primeng/panelmenu';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';


import { PopoverModule } from 'primeng/popover';
import { UserStore } from 'src/app/core/auth/user/store/user.store';
import { LayoutService } from '../../service/layout.service';
import { Client } from 'src/app/shared/models/client.model';
import { User } from 'src/app/core/auth/user/models/user';

@Component({
  selector: 'app-active-tenant-menu',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    PanelMenuModule,
    OverlayPanelModule,
    ButtonModule,
    TooltipModule,
    PopoverModule,
  ],
  templateUrl: './active-tenant-menu.component.html',
  styleUrl: './active-tenant-menu.component.css',
})
export class ActiveTenantMenuComponent {
  userStore = inject(UserStore);
  layoutService = inject(LayoutService);

  @ViewChild('tenantOp') tenantOp!: OverlayPanel;

  userTenants = computed<Client[]>(() =>
    this.getTenantsFromUser(this.userStore.user() as User),
  );
  activeTenant = this.userStore.activeTenant;
  tenantShort = computed(() => {
    const name = this.activeTenant()?.name ?? '';
    const parts = name.trim().split(/\s+/).filter(Boolean);
    const letters = parts.slice(0, 2).map((p) => p[0]?.toUpperCase() ?? '');
    return letters.join('') || name.slice(0, 2).toUpperCase();
  });
  // für static mode (dein PanelMenu)
  tenantMenuItems = computed<MenuItem[]>(() => {
    const tenants = this.userTenants() ?? [];
    const active = this.activeTenant();

    if (!active || tenants.length === 0) return [];

    if (tenants.length === 1) {
      return [{ label: active.name, disabled: true }];
    }

    return [
      {
        label: active.name,
        expanded: false,
        items: tenants.map((t) => ({
          label: t.name,
          command: () => this.selectTenant(t),
        })),
      },
    ];
  });

  constructor() {
    effect(() => {
      if (this.userTenants().length > 0 && this.activeTenant() == null) {
        this.selectTenant(this.userTenants()[0] as Client);
      }
    });
  }

  toggleTenantOverlay(event: MouseEvent) {
    // wenn nur 1 tenant, kein overlay öffnen
    if ((this.userTenants()?.length ?? 0) <= 1) return;
    this.tenantOp.toggle(event);
  }

  selectTenant(tenant: Client): void {
    this.userStore.setActiveNectaTenant(tenant);
  }

  // Extrahiert die eindeutigen Tenants aus dem UserProfile.
  private getTenantsFromUser(user: User): Client[] {
    let tenants: Client[] = [];
    console.log('User Tenants:', user);
    user.clients?.forEach((u) => {
      if (!tenants.some((x) => u.id == x.id))
        tenants.push(u);
    });
    return tenants;
  }
}
